//文件相关工具

const TT_UPLOAD_UNSUPPORTED_FILE_NAME_PATTERN = /[#%&\\"<>?$+,，]/g;

/**
 * 获取 TTUploader 文件名校验错误
 * 只提示当前文件名实际命中的不支持字符，多个相同字符去重展示
 */
export const getTTUploadFileNameError = (fileName: string) => {
  const unsupportedCharacters = [
    ...new Set(fileName.match(TT_UPLOAD_UNSUPPORTED_FILE_NAME_PATTERN) || []),
  ];
  if (!unsupportedCharacters.length) return undefined;

  return `文件名不能包含以下字符：${unsupportedCharacters.join('、')}，请修改文件名后重试`;
};

/**
 * 计算空间大小
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

/**
 * 将字符串大小描述转为 bytes,支持的单位：b、kb、mb、gb不区分大小写，b可省略不写
 *  @param size 字符串大小描述
 *  @returns bytes
 *  @example
 *
 * parseFileSize('1KB') // 1024
 * parseFileSize('1M') // 1048576
 * parseFileSize('1MB') // 1048576
 * parseFileSize('1GB') // 1073741824
 */
export const parseFileSize = (size: string): number => {
  let _size = size.toUpperCase().replace(/\s/g, '');
  if (size.endsWith('B')) {
    _size = size.slice(0, -1);
  }
  const units = {
    K: 1024,
    M: Math.pow(1024, 2),
    G: Math.pow(1024, 3),
  };
  const unit = _size.match(/[KMG]/);
  if (unit) {
    const num = parseFloat(_size.split(unit[0])[0]);
    return num * units[unit[0] as keyof typeof units];
  } else {
    return parseInt(_size, 10);
  }
};
